import filter from '@/api/filter';
export const config = {
  data() {
    return {
      columns: []
    };
  },
  mounted() {
    this.getColumns();
  },
  methods: {
    getColumns() {
      let tabWidth = 120;
      if(this.$units.isOkBao() && this.status == 0){
        tabWidth = 220;
      }else if(this.$units.isOkBao() && this.status == 9) {
        tabWidth = 160;
      }
      let columns = [
        {
          type: 'selection',
          width: 60,
          fixed: 'left',
          align: 'center'
        },
        {
          title: '业务员姓名',
          key: 'userName',
          minWidth: 200,
          fixed: 'left',
          align: 'center',
          slot: 'userName_staffNo'
        },
        {
          title: '状态',
          minWidth: 120,
          align: 'center',
          fixed: 'left',
          slot: 'status'
        },
        {
          title: '申请金额',
          key: 'requestAmount',
          minWidth: 140,
          align: 'center'
        },
      ];
      // ok保提现成功显示
      if(this.$units.isOkBao()) {
        columns.push({
          title: '结算主体',
          key: 'settlementEntity',
          minWidth: 160,
          align: 'center'
        });
      }
      columns = columns.concat([
        {
          title: '所属机构',
          key: 'orgName',
          minWidth: 160,
          align: 'center'
        },
        {
          title: '所属团队',
          key: 'groupName',
          minWidth: 160,
          align: 'center'
        },
        {
          title: '证件类型',
          key: 'cardType',
          minWidth: 130,
          align: 'center'
        },
        {
          title: '证件号',
          slot: 'idNo',
          minWidth: 180,
          align: 'center'
        },
        {
          title: '银行预留手机号',
          slot: 'mobile',
          minWidth: 160,
          align: 'center'
        },
        {
          title: '开户行',
          key: 'bank',
          minWidth: 160,
          align: 'center'
        },
        {
          title: '银行账号',
          slot: 'cardNo',
          minWidth: 200,
          align: 'center'
        },
        {
          title: '申请时间',
          key: 'requestTime',
          minWidth: 140,
          align: 'center',
          tooltip: true,
          render(h, params) {
            const time = filter.filterTime(params.row.requestTime, 'YYYY-MM-DD');
            return <span>{time}</span>;
          }
        },
        {
          title: '提现资料',
          key: 'resource',
          minWidth: 130,
          align: 'center',
          slot: 'resource'
        },
      ])
      // ok保提现成功显示
      if(this.status == 1 && this.$units.isOkBao()) {
        columns.push({
          title: '打款账户',
          key: 'accountName',
          minWidth: 240,
          align: 'center'
        });
      }
      columns = columns.concat([
        {
          title: '打款日期',
          key: 'paymentTime',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            const paymentTime = params.row.paymentTime;
            return <span>{paymentTime ? filter.filterTime(paymentTime, 'YYYY-MM-DD') : ''}</span>;
          }
        },
        {
          title: '备注',
          tooltip: true,
          key: 'remark',
          minWidth: 180,
          align: 'center'
        },
        {
          title: '操作',
          slot: 'action',
          className: 'action-columns',
          width: tabWidth,
          fixed: 'right',
          align: 'center'
        }
      ]);
      this.columns = columns;
    }
  }
};
